import { createWeb3Modal } from '@web3modal/wagmi/react'

import { http, createConfig, WagmiProvider } from 'wagmi'
import { arbitrum, arbitrumSepolia, bsc, bscTestnet, polygon, polygonAmoy } from 'wagmi/chains'
import { walletConnect, injected, coinbaseWallet, metaMask } from 'wagmi/connectors'

import { QueryClient, QueryClientProvider } from '@tanstack/react-query'


const queryClient = new QueryClient()
const projectId = process.env.REACT_APP_WALLETCONNECT_PROJECT_ID

export const supportedChains = process.env.REACT_APP_PNFT_NETWORK == "polygon+mainnet"
? [arbitrum, bsc, polygon]
: [arbitrumSepolia, bscTestnet, polygonAmoy];

export const networkMapping = {
  "polygon+mainnet": polygon.id,
  "polygon+amoy": polygonAmoy.id,
  "bsc+mainnet": bsc.id,
  "bsc+testnet": bscTestnet.id
}


// 2. Create wagmiConfig
const metadata = {
  name: 'opencampus',
  description: 'Open Campus',
  url: 'https://opencampus.xyz/', // origin must match your domain & subdomain
  icons: ['https://opencampus.xyz/favicon.ico']
}

const config = createConfig({
  chains: supportedChains,
  transports: {
    [arbitrum.id]: http("https://arb-mainnet.g.alchemy.com/v2/aEPj2MWEm0rSO5MqorCPgULxk-4DOUxX"),
    [arbitrumSepolia.id]: http("https://arb-sepolia.g.alchemy.com/v2/pxtL42td-pG84AqTtJDTT5MeKNZNPZRV"),
    [polygon.id]: http("https://polygon-mainnet.g.alchemy.com/v2/48MuJJ9XXqm5OuaDsDKPYok0EtNyzA8A"),
    [polygonAmoy.id]: http("https://polygon-amoy.g.alchemy.com/v2/6HiL4BPUHdRV03rp5jrh9ziMfa8uYXzU"),
    [bsc.id]: http("https://bsc-dataseed.bnbchain.org"),
    [bscTestnet.id]: http("https://morning-tiniest-violet.bsc-testnet.quiknode.pro/810321b26bb3d0719828fdefb66d0c1fde81f0b7/")
  },
  connectors: [
    // metaMask({ injectProvider: false,  }),
    walletConnect({ projectId, metadata, showQrModal: false }),
    injected({ shimDisconnect: true }),
    coinbaseWallet({
      appName: metadata.name,
      appLogoUrl: metadata.icons[0]
    }),
    // safe()
  ]
})

// 3. Create modal
createWeb3Modal({
  wagmiConfig: config,
  projectId,
  enableAnalytics: true, // Optional - defaults to your Cloud configuration
  allWallets: "HIDE",
  includeWalletIds: [
    'c57ca95b47569778a828d19178114f4db188b89b763c899ba0be274e97267d96', // metamask
    'e7c4d26541a7fd84dbdfa9922d3ad21e936e13a7a0e44385d44f006139e44d3b', // walletconnect
    '1ae92b26df02f0abca6304df07debccd18262fdf5fe82daa81593582dac9a369', // coinbase
    '19177a98252e07ddfc9af2083ba8e07ef627cb6103467ffebb3f8f4205fd7927', // ledger
    '971e689d0a5be527bac79629b4ee9b925e82208e5168b733496a09c0faed0709', // okx
    'c03dfee351b6fcc421b4494ea33b9d4b92a984f87aa76d1663bb28705e95034a', // uniswap
    '1ae92b26df02f0abca6304df07debccd18262fdf5fe82daa81593582dac9a369', // rainbow
  ],
  featuredWalletIds: [
    'c57ca95b47569778a828d19178114f4db188b89b763c899ba0be274e97267d96', // metamask
    'e7c4d26541a7fd84dbdfa9922d3ad21e936e13a7a0e44385d44f006139e44d3b', // walletconnect
    '1ae92b26df02f0abca6304df07debccd18262fdf5fe82daa81593582dac9a369', // coinbase
    '19177a98252e07ddfc9af2083ba8e07ef627cb6103467ffebb3f8f4205fd7927', // ledger
    '971e689d0a5be527bac79629b4ee9b925e82208e5168b733496a09c0faed0709', // okx
    'c03dfee351b6fcc421b4494ea33b9d4b92a984f87aa76d1663bb28705e95034a', // uniswap
    '1ae92b26df02f0abca6304df07debccd18262fdf5fe82daa81593582dac9a369', // rainbow
  ],
  enableOnramp: false,
  themeVariables: {
    '--w3m-z-index': 1050
  }
})

export function WalletConnectProvider({ children }) {
  return (
    <WagmiProvider config={config}>
      <QueryClientProvider client={queryClient}>{children}</QueryClientProvider>
    </WagmiProvider>
  )
}